module.exports = __webpack_public_path__ + "static/image1-f78522f2385a7239f317a5fa842c9a2b.jpg";